import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import { DownloadOutlined, UserOutlined, CloseOutlined } from '@ant-design/icons';
import { getProductSearchResult } from "../../../actions/productDetails";
import { getProductSearchResultforsales } from "../../../actions/productDetails";
import { DeleteOutlined, CaretRightOutlined } from "@ant-design/icons";
import {  createInvoiceItem, createInvoice, createService, updateInvoice,} from "../../../actions/invoiceItem";
import { getAllEmployee } from "../../../actions/employeeAction";
import { updateVariationfromSrock } from "../../../actions/variableProductAction";
import { getSpecificChartofaccountsbycode } from "../../../actions/chartofaccountsAction";
import { updateCupon } from "../../../actions/cupon";
import { getAllOutlet } from "../../../actions/warehouseAction";
import { createMeasurement } from "../../../actions/measurment";
import { createjournals } from "../../../actions/journalAction";
import { getAllAccount } from "../../../actions/accountsAction";
import { getCuponSearchResult } from "../../../actions/cupon";
import { getContactSearchResultbyPhone, getSpecificContact,} from "../../../actions/contactAction";
import { getSpecificMeasurementbycontact } from "../../../actions/measurment";
import CreateNewContct from "./CreateNewContct";
import AddShipping from "../AddShipping";
// import ContctSearch from "./ContctSearch";
import dateFormat from "dateformat";

import {
  Divider, AutoComplete, Row, Col, Image, InputNumber, Affix, Button, message, DatePicker, Space, Select, Input, TreeSelect, Switch, Collapse, Form, } from "antd";
const { Option } = Select;
const { Panel } = Collapse;

const SearchStock = ({
  getProductSearchResult, List, WarehouseList, Contacts, cartItems, setCart, cart, createInvoiceItem,  createInvoice, updateVariationfromSrock, createService, getAllOutlet, createMeasurement, createjournals,  getAllAccount, location, getSpecificChartofaccountsbycode, setshowinvoice, newinvoice,getCuponSearchResult, updateCupon, setsearch, Auth, updateInvoice, packagingItems, setrealodpackage, fullpageloading, getAllEmployee, employeeList, getProductSearchResultforsales, getContactSearchResultbyPhone, getSpecificMeasurementbycontact,
  getSpecificContact, triggerOpen 
}) => {
  const { id } = useParams();
  var formatter = new Intl.NumberFormat("en-IN");
  const services = useRef([]);
  const measurements = useRef([]);
  const packaging = useRef([]);

  const [showsuggetion, setshowsuggetion] = useState(false);
  const [contactsuggetions, setcontactsuggetions] = useState();
  const [contact, setcontact] = useState({});
  const [remove, setremove] = useState(false);
  const [timer, setTimer] = useState(null);
  const [searchPhone, setSearchPhone] = useState("");

  const [servicetrigger, setservicetrigger] = useState(false);
  const [accounts, setaccounts] = useState([]);
  const [receive, setReceive] = useState(0);
  const [paidError, setPaidError] = useState(null);
  const [triggerDrawer, setTriggerDrawer] = useState(false);

  const productSearchRef = useRef(null);
  const contactSearchRef = useRef(null);
  const salesDiscountRef = useRef(null);
  const productDiscountRef = useRef(null);
  const confirmOrderRef = useRef(null);
  const [data, setdata] = useState([]);
  const [form] = Form.useForm();

    useEffect(() => {
      // if (!document.activeElement || document.activeElement === document.body) {
        if (productSearchRef.current) {
          productSearchRef.current.focus();
        }
      // }
    }, []);

    // TAB/ENTER
    const handleKeyDown = (event) => {
      if (event.key === "Tab") {
        event.preventDefault();
    
        console.log("Current focused element:", document.activeElement);
    
        if (event.shiftKey) {
          if (confirmOrderRef.current && document.activeElement === confirmOrderRef.current) {
            console.log("Shifting focus to salesDiscountRef");
            if (salesDiscountRef.current) salesDiscountRef.current.focus();
          } else if (salesDiscountRef.current && document.activeElement === salesDiscountRef.current) {
            console.log("Shifting focus to contactSearchRef");
            if (contactSearchRef.current && contactSearchRef.current.input) contactSearchRef.current.input.focus();
          } else if (contactSearchRef.current && contactSearchRef.current.input && document.activeElement === contactSearchRef.current.input) {
            console.log("Shifting focus to productSearchRef");
            if (productSearchRef.current && productSearchRef.current.input) productSearchRef.current.input.focus();
          }
        } else {
          if (productSearchRef.current && productSearchRef.current.input && document.activeElement === productSearchRef.current.input) {
            console.log("Shifting focus to salesDiscountRef");
            setTriggerDrawer(true);
          } else if (contactSearchRef.current && contactSearchRef.current.input && document.activeElement === contactSearchRef.current.input) {
            console.log("Shifting focus to salesDiscountRef");
            if (salesDiscountRef.current) salesDiscountRef.current.focus();
          } else if (salesDiscountRef.current && document.activeElement === salesDiscountRef.current) {
            console.log("Shifting focus to confirmOrderRef");
            if (confirmOrderRef.current) confirmOrderRef.current.focus();
          }
        }
      } else if (event.key === "Enter") {
        if (confirmOrderRef.current && document.activeElement === confirmOrderRef.current) {
          submitOrder();
          event.preventDefault();
          setTimeout(() => {
            if (salesDiscountRef.current) {
              salesDiscountRef.current.focus();
            }
          }, 200);
        }
      }
    };
    

  // Product
  useEffect(() => {
    if (triggerDrawer) {
      setTimeout(() => setTriggerDrawer(false), 500);
    }
  }, [triggerDrawer]);

  const handleDrawerClose = () => {
    setTimeout(() => {
      if (salesDiscountRef.current) {
        console.log("Focusing salesDiscountRef after closing drawer");
        salesDiscountRef.current.focus();
      }
    }, 300); 
  };

  const onKeyUp = (event) => {
    if (location.current == "") {
      alert("Please select a outlet first");
    } else {
      if (event.keyCode == 13) {
        if (event.target.value != "") {
          let loc = "";
          if (location.current != 6) {
            loc = location.current;
          }
          getProductSearchResultforsales(event.target.value, loc, 1, 100).then(
            (res) => {
              // setsearch(false);
              setdata(res.results);

              if (res.count == 1) {
                res.results.map((item) => {
                  console.log(item);
                  if (item.is_active) {
                    let newdiscount = 0;
                    if (item.Deatils[0].discount != null) {
                      newdiscount = item.Deatils[0].discount;
                      if (item.Deatils[0].discount_type == "%") {
                        newdiscount =
                          (item.selling_price * item.Deatils[0].discount) / 100;
                      }
                    }
                    console.log("match");
                    if (cartItems.current.length > 0) {
                      let flag = 0;
                      console.log(cartItems)
                      cartItems.current.map((cartitem, index) => {
                        if (cartitem.id == item.id) {
                          cartitem.quantity = cartitem.quantity + 1;
                          cartitem.total_price =
                            parseFloat(cartitem.total_price) +
                            parseFloat(item.selling_price);
                          if (cartitem.quantity > cartitem.limit) {
                            alert("out of stock");
                            cartitem.quantity = cartitem.quantity - 1;
                            cartitem.total_price =
                              parseFloat(cartitem.total_price) -
                              parseFloat(item.selling_price);
                          } else {
                            message.success(
                              item.Deatils[0].title + " has been added"
                            );
                            productSearchRef.current.focus();
                          }
                          flag = 1;
                        }
                      });
                      if (flag == 0) {
                        const arr = {
                          id: item.id,
                          title: item.Deatils[0].title,
                          product_code: item.Deatils[0].product_code,
                          color: item.color,
                          Color: item.Color,
                          size: item.size,
                          Size: item.Color,
                          purchase_price: item.purchase_price,
                          price: item.selling_price,
                          total_price: item.selling_price,
                          quantity: 1,
                          limit: item.quantity,
                          discount: newdiscount,
                          product_discount: item.Deatils[0].product_discount,
                          product_discount_reduce: ((item.selling_price * (item.Deatils[0].product_discount / 100)))

                        };

                        message.success(
                          item.Deatils[0].title + " has been added"
                        );
                        cartItems.current.push(arr);
                        setTimeout(() => productSearchRef.current.focus(), 0);
                      }
                      setCart(true);
                    } else {
                      const arr = {
                        id: item.id,
                        title: item.Deatils[0].title,
                        product_code: item.Deatils[0].product_code,
                        color: item.color,
                        Color: item.Color,
                        size: item.size,
                        Size: item.Color,
                        purchase_price: item.purchase_price,
                        price: item.selling_price,
                        total_price: item.selling_price,
                        quantity: 1,
                        limit: item.quantity,
                        discount: newdiscount,
                        product_discount: item.Deatils[0].product_discount,
                        product_discount_reduce: ((item.selling_price * (item.Deatils[0].product_discount / 100)))
                      };

                      message.success(
                        item.Deatils[0].title + " has been added"
                      );
                      cartItems.current.push(arr);
                      setTimeout(() => productSearchRef.current.focus(), 0);
                    }
                    setCart(true);
                    form.resetFields();
                    setTimeout(() => productSearchRef.current.focus(), 0);
                  }
                });
              }
            }
          );
        } else {
          setdata([]);
        }
      }
    }
  };


  // CONTACT SEARCH
  useEffect(() => {
      if (id > 0) {
        getSpecificContact(id).then((response) => {
          if (typeof response != "undefined") {
            getSpecificMeasurementbycontact(id).then((measurement) => {
              if (typeof measurement != "undefined") {
                bill.current.basicmeasurement = measurement[0];
              }
              setcontact(response);
              bill.current.Contact = response.id;
              if (parseFloat(response.account_balance) > 0) {
                bill.current.Payable = parseFloat(response.account_balance);
              } else {
                bill.current.Payable = 0;
              }
              setshowsuggetion(false);
              setremove(true);
              setCart(true);
            });
          }
        });
      }
    }, [id, getSpecificContact, getSpecificMeasurementbycontact, bill, setCart]);

  const onChangeContact = (e) => {
    const value = e.target.value;
    setSearchPhone(value);

    if (timer) {
      clearTimeout(timer);
    }

    if (value.length === 2) {
      setTimer(
        setTimeout(() => {
          getContactSearchResultbyPhone(value).then((result) => {
            setcontactsuggetions(result);
            setshowsuggetion(true);
          });
        }, 2000)
      );
    } else if (value.length > 2) {
      getContactSearchResultbyPhone(value).then((result) => {
        setcontactsuggetions(result);
        setshowsuggetion(true);
      });
    } else {
      setshowsuggetion(false);
    }
  };

  const renderContact = () => {
    if (showsuggetion) {
      return (
        <>
          {/* Close button for suggestions */}
          <Row
            style={{
              backgroundColor: "#fff",
              padding: "5px 10px",
              borderBottom: "1px solid lightgray",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "12px", color: "#666" }}>
              Search Results
            </span>
            <Button
              type="text"
              size="small"
              icon={<CloseOutlined />}
              onClick={() => {
                setshowsuggetion(false);
                setSearchPhone("");
              }}
              style={{ fontSize: "12px" }}
            >
              Close
            </Button>
          </Row>

          {/* Contact suggestions list */}
          {contactsuggetions.map((contact, index) => {
            if ((contact.Type == "Customer" || contact.Type == null) && index < 10) {
              return (
                <Row
                  key={contact.id}
                  style={{
                    border: "1px solid lightgray",
                    padding: "5px",
                    marginBottom: "1px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setcontact(contact);
                    getCuponSearchResult(contact.Cupon).then((result) => {
                      if (result.length === 1 && result[0].status === "Active") {
                        if (
                          (result[0].limit_type === "limited" &&
                            result[0].limit > 0) ||
                          result[0].limit_type === "Unlimited"
                        ) {
                          const currentdate = new Date();

                          const d1 = dateFormat(
                            result[0].start,
                            "yyyy-mm-dd HH:MM:ss"
                          );
                          const d2 = dateFormat(result[0].end, "yyyy-mm-dd HH:MM:ss");
                          const current = dateFormat(
                            currentdate,
                            "yyyy-mm-dd HH:MM:ss"
                          );
                          const date1 = new Date(d1);
                          const date2 = new Date(d2);
                          const currenttime = new Date(current);

                          const diff1 = currenttime.getTime() - date1.getTime();
                          const diff2 = date2.getTime() - currenttime.getTime();
                          const lte = diff1 / (1000 * 3600 * 24);
                          const gte = diff2 / (1000 * 3600 * 24);

                          if (lte >= 0 && gte >= 0) {
                            message.success("Coupon has been applied");
                            bill.current.Cupon = result[0];
                            setCart(true);
                          }
                        }
                      }
                    });

                    bill.current.Contact = contact.id;
                    if (parseFloat(contact.account_balance) > 0) {
                      bill.current.Payable = parseFloat(contact.account_balance);
                    } else {
                      bill.current.Payable = 0;
                    }

                    setshowsuggetion(false);
                    setremove(true);
                    setCart(true);
                  }}
                >
                  <Col span={17}>
                    <h4 style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                      {contact.name}
                    </h4>
                  </Col>
                  <Col span={6}>{contact.phone}</Col>
                </Row>
              );
            }
            return null;
          })}
        </>
      );
    }
  };


  var currentdate = new Date();
  function disabledDate(current) {
    // Can not select days before today and today
    return current && current < moment(currentdate, "YYYY-MM-DD");
  }
  var todayDate = 
    currentdate.getDate().toString() + "-" +
    (currentdate.getMonth() + 1).toString().padStart(2, "0") + "-" +
    currentdate.getFullYear().toString()

  var orderNumber = 
    currentdate.getHours().toString() +
    currentdate.getMinutes().toString() +
    currentdate.getSeconds().toString();

  var invoiceNumber =
    currentdate.getDate().toString() +
    (currentdate.getMonth() + 1).toString() +
    currentdate.getFullYear().toString() +
    currentdate.getHours().toString() +
    currentdate.getMinutes().toString() +
    currentdate.getSeconds().toString();
  const bill = useRef({
    Contact: null,
    basicmeasurement: { Note: "" },
    MaxDiscount: 0,
    Discount: 0,
    SpecificDiscount: 0,
    AdjustmentDiscount: 0,
    subTotal: 0,
    Total: 0,
    ProductDiscountTotal: 0,
    TotalSell: 0,
    Due: 0,
    Refund: 0,
    Receive: 0,
    Tax: 0,
    Cost: 0,

    //payment 1
    Paid: 0, 
    PaymentMethod: "Cash", 
    AccountNumber: "",
    Account_no: "", 
    transection: "", 

    //payment 2
    Paid_2: 0, 
    PaymentMethod_2: "Cash", 
    AccountNumber_2: "", 
    Account_no_2: "", 
    transection_2: "", 
    payment2_active: false, 

    Issue: "",
    Deliver: "",
    DeliveryCharge: 0,
    InvoiceNumber: invoiceNumber,
    OrderNumber: orderNumber,
    TodayDate:todayDate,
    shipping_address: "",
    remarks: "",
    location: Auth.profile.Office,
    Program: "",
    Cupon: null,
    Cupon_name: "",
    Payable: 0,
    AddPayable: false,
    Advance: null,
    Sales_person: Auth.profile.id,
  });
  console.log(Auth)

  useEffect(() => {
    getAllAccount().then((result) => {
      setaccounts(result);
    });
    getAllEmployee();
    getAllOutlet();
    location.current = bill.current.location;
  }, []);

  useEffect(() => {
    let Total = 0;
    let ProductDiscountTotal = 0;
    let SpecificDiscount = 0;
    let totalQty = 0;
    let maxdiscount = 0;
    let Totalcost = 0;
    let productprice = 0;
    bill.current.TotalSell = 0;
    console.log(bill.current)
    console.log(bill.current.SpecificDiscount)
    cartItems.current.map((item) => {
      Total += parseFloat(item.total_price);
      ProductDiscountTotal += parseFloat(item.product_discount_reduce) * item.quantity;
      SpecificDiscount += parseFloat(item.spec_discount) || 0;
      console.log(cartItems)
      bill.current.TotalSell += parseFloat(item.total_price);
      productprice += parseFloat(item.total_price);
      Totalcost += parseFloat(item.purchase_price) * item.quantity;
      totalQty += item.quantity; 
      if (bill.current.Cupon == null) {
        maxdiscount += parseFloat(item.discount) * item.quantity;
      }
    });

    bill.current.ProductDiscountTotal = ProductDiscountTotal;
    bill.current.SpecificDiscount = SpecificDiscount
    bill.current.Cost = Totalcost;
    bill.current.MaxDiscount = maxdiscount;
    services.current.map((item) => {
      Total += parseFloat(item.Total_Price);
    });

    if (bill.current.DeliveryCharge > 0) {
      bill.current.subTotal =
        parseFloat(Total) + parseFloat(bill.current.DeliveryCharge);
    } else {
      bill.current.subTotal = parseFloat(Total) + parseFloat(0);
    }
    bill.current.Total = bill.current.subTotal;
    console.log(bill.current.subTotal)


    //cupon
    if (bill.current.Cupon != null) {
      if (bill.current.Cupon.ref_type == "A") {
        bill.current.Discount = parseFloat(bill.current.Cupon.amount);
      } else {
        bill.current.Discount = parseFloat(
          (bill.current.TotalSell * bill.current.Cupon.amount) / 100
        );
      }
    }

    if (bill.current.Discount > 0 || bill.current.ProductDiscountTotal > 0 || bill.current.SpecificDiscount > 0 ) {
      bill.current.Total =
        parseFloat(bill.current.subTotal) 
        - parseFloat(bill.current.Discount) 
        - parseFloat(bill.current.ProductDiscountTotal) 
        // - parseFloat(bill.current.SpecificDiscount);
        console.log(bill.current.SpecificDiscount)
        console.log(bill.current.Total)
        console.log(bill.current.subTotal)
      bill.current.subTotal =
      parseFloat(bill.current.Total) 
      + parseFloat(bill.current.Discount) 
      + parseFloat(bill.current.ProductDiscountTotal)
      + parseFloat(bill.current.SpecificDiscount) 
    } else {
      bill.current.Total = parseFloat(bill.current.subTotal) - parseFloat(0);
    }
    if (bill.current.Total < 0) {
      bill.current.Total = 0;
    }

    //previous payment
    if (bill.current.Payable > 0 && bill.current.AddPayable) {
      if (bill.current.Total > bill.current.Payable) {
        bill.current.Advance = bill.current.Payable;
      } else {
        bill.current.Advance = bill.current.Total;
      }
    } else {
      bill.current.Advance = 0;
    }

    //////////////////// Due count
    if (bill.current.Total == bill.current.Paid) {
      bill.current.Paid_2 = 0;
    }
    if (bill.current.Paid == 0) {
      bill.current.Paid_2 = 0;
    }
    if (bill.current.Paid > 0 || bill.current.Paid == 0) {
      bill.current.Due =
        parseFloat(bill.current.Total) -
        parseFloat(bill.current.Paid) -
        // parseFloat(receive) -
        parseFloat(bill.current.Paid_2) -
        parseFloat(bill.current.Advance);
    }
  
    productprice = productprice - bill.current.Discount;
    bill.current.Tax = Math.abs(productprice - productprice / (1 + 0.075));
    bill.current.totalQty = totalQty;
    setservicetrigger(false);
    setCart(false);
    setReceive(bill.current.Total); 
  }, [cart, servicetrigger]);

  useEffect(() => {
    bill.current.Paid = receive;
    console.log(bill.current.Due)
    console.log(bill.current.Total)
    console.log(receive)
    console.log(bill.current.Paid_2)
    console.log(bill.current.Advance)
    bill.current.Due =
      parseFloat(bill.current.Total) -
      parseFloat(receive) -
      parseFloat(bill.current.Paid_2) -
      parseFloat(bill.current.Advance);

  }, [receive]);

  // Submit Order
  const submitOrder = async () => {
    // Check if browser is online
    if (!navigator.onLine) {
      message.error("Network is offline. Please check your internet connection and try again.");
      return;
    }

    if (bill.current.Paid <= 0) {
      setPaidError("Please enter a valid Receive amount");
      return;
    }

    const formData = new FormData();
    if (bill.current.PaymentMethod != "Cash") {
      formData.append("account", bill.current.AccountNumber);
    } else {
      for (let i = 0; i < accounts.length; i++) {
        if (accounts[i].type == bill.current.PaymentMethod) {
          formData.append("account", accounts[i].id);
          bill.current.AccountNumber = accounts[i].id;
        }
      }
    }
    if (bill.current.Due < 0) {
      bill.current.Receive = bill.current.Total + Math.abs(bill.current.Due);
      bill.current.Refund = Math.abs(bill.current.Due);
      bill.current.Due = 0;
      bill.current.Paid = bill.current.Total;
      formData.append("refund", bill.current.Refund.toFixed(2));
      formData.append("receive", bill.current.Receive);
    } else {
      bill.current.Receive = bill.current.Paid;
      formData.append("receive", bill.current.Receive);
    }

    if (
      bill.current.Contact == null ||
      bill.current.Sales_person == null
    ) {
      setTriggerDrawer(true);
      return;
    } else if (bill.current.Paid_2 > 0 && bill.current.PaymentMethod_2 == "") {
      alert("Please Insert a payment method");
      return;
    }

    fullpageloading(true);

    try {
      formData.append("contact", bill.current.Contact);
      formData.append("bill", bill.current.Total.toFixed(2));
      formData.append("discount", bill.current.Discount.toFixed(2));
      formData.append("additional_discount", bill.current.ProductDiscountTotal.toFixed(2));
      formData.append("spec_item_discount", bill.current.SpecificDiscount.toFixed(2) || 0);
      formData.append("delivery_charge", bill.current.DeliveryCharge.toFixed(2));
      if (bill.current.Advance > 0) {
        formData.append("advance_payment", bill.current.Advance.toFixed(2));
        formData.append("payment", (bill.current.Paid + bill.current.Advance).toFixed(2));
      } else {
        formData.append("payment", bill.current.Paid.toFixed(2));
      }
      formData.append("due", bill.current.Due.toFixed(2));
      formData.append("Payment_method", bill.current.PaymentMethod);
      formData.append("issue_date", bill.current.Issue);
      if (bill.current.Deliver != "") {
        formData.append("delivery_date", bill.current.Deliver);
      }
      if (bill.current.Program != "") {
        formData.append("program_date", bill.current.Program);
      }
      formData.append("invoice_number", bill.current.InvoiceNumber);
      formData.append("discountlimit", bill.current.MaxDiscount);
      formData.append("shipping_address", bill.current.shipping_address);
      formData.append("Account_no", bill.current.Account_no);
      formData.append("Transection_no", bill.current.transection);
      formData.append("tax", bill.current.Tax.toFixed(2));
      formData.append("remarks", bill.current.remarks);
      formData.append("location", bill.current.location);
      formData.append("costing", bill.current.Cost.toFixed(2));
      formData.append("employe", Auth.profile.id);
      formData.append("Sales_person", bill.current.Sales_person);
      if (Auth.profile && Auth.profile.name) {
        formData.append("invoice_by", Auth.profile.name);
      }
      if (bill.current.Cupon != null) {
        formData.append("cupon", bill.current.Cupon.id);
      }
      formData.append("data", "");
      let totalquantity = 0;
      for (let c = 0; c < cartItems.current.length; c++) {
        totalquantity += cartItems.current[c].quantity;
      }
      for (let s = 0; s < services.current.length; s++) {
        totalquantity += services.current[s].Quantity;
      }
      formData.append("quantity", totalquantity);

      let promises = [];
      const result = await createInvoice(formData).catch(() => {
        message.error("Network error: Unable to create invoice. Please try again.");
        fullpageloading(false);
        return null;
      });
      if (!result) return; // Stop if invoice creation failed

      async function someProcedure() {
        let formData = new FormData();

        // Product items
        for (let c = 0; c < cartItems.current.length; c++) {
          var newstock = cartItems.current[c].limit - cartItems.current[c].quantity;
          formData = new FormData();
          formData.append("invoice", result);
          formData.append("product", cartItems.current[c].id);
          formData.append("price", cartItems.current[c].price);
          formData.append("purchase_price", cartItems.current[c].purchase_price);
          formData.append("quantity", cartItems.current[c].quantity);
          formData.append("spec_discount", cartItems.current[c].spec_discount || 0);
          formData.append("data", "");
          promises.push(createInvoiceItem(formData).catch(() => {
            throw new Error("Network error: Unable to create invoice item.");
          }));
          formData = new FormData();
          formData.append("quantity", newstock);
          promises.push(updateVariationfromSrock(cartItems.current[c].id, formData, newstock).catch(() => {
            throw new Error("Network error: Unable to update stock.");
          }));
        }

        // Packaging items
        let packaging_cost = 0;
        for (let p = 0; p < packagingItems.length; p++) {
          if (packagingItems[p].quantity > 0) {
            var newpackagingstock = packagingItems[p].limit - packagingItems[p].quantity;
            packaging_cost = packaging_cost + parseFloat(packagingItems[p].price);
            const formData = new FormData();
            formData.append("quantity", newpackagingstock);
            promises.push(updateVariationfromSrock(packagingItems[p].id, formData, newpackagingstock).catch(() => {
              throw new Error("Network error: Unable to update packaging stock.");
            }));
          }
        }

        // Services
        for (let s = 0; s < services.current.length; s++) {
          const formData = new FormData();
          formData.append("invoice", result);
          formData.append("details", services.current[s].Description);
          formData.append("price", services.current[s].Price);
          formData.append("quantity", services.current[s].Quantity);
          if (services.current[s].product > 0) {
            formData.append("product", services.current[s].product);
          }
          formData.append("status", "Pending");
          formData.append("data", "");
          promises.push(
            createService(formData).then((newservice) => {
              for (let m = 0; m < measurements.current.length; m++) {
                if (measurements.current[m].serviceindex == s) {
                  measurements.current[m].invoice = result;
                  measurements.current[m].service = newservice.id;
                  measurements.current[m].data = "";
                  promises.push(createMeasurement(measurements.current[m]).catch(() => {
                    throw new Error("Network error: Unable to create measurement.");
                  }));
                }
              }
            }).catch(() => {
              throw new Error("Network error: Unable to create service.");
            })
          );
        }

        for (let i = 0; i < measurements.current.length; i++) {
          if (typeof measurements.current[i].serviceindex == "undefined") {
            measurements.current[i].invoice = result;
            measurements.current[i].data = "";
            promises.push(createMeasurement(measurements.current[i]).catch(() => {
              throw new Error("Network error: Unable to create measurement.");
            }));
          }
        }

        formData = new FormData();
        if (
          bill.current.Cupon != null &&
          bill.current.Cupon.limit_type == "limited"
        ) {
          var newLimit = parseInt(bill.current.Cupon.limit) - 1;
          formData.append("limit", newLimit);
          promises.push(updateCupon(bill.current.Cupon.id, formData).catch(() => {
            throw new Error("Network error: Unable to update coupon.");
          }));
        }

        // 2nd payment
        if (bill.current.Paid_2 > 0) {
          formData = new FormData();
          if (bill.current.PaymentMethod_2 != "Cash") {
            formData.append("account", bill.current.AccountNumber_2);
          } else {
            for (let i = 0; i < accounts.length; i++) {
              if (accounts[i].type == bill.current.PaymentMethod_2) {
                formData.append("account", accounts[i].id);
              }
            }
          }
          let total_payment = 0;
          if (bill.current.Advance > 0) {
            total_payment = bill.current.Paid_2 + bill.current.Paid + bill.current.Advance;
          } else {
            total_payment = bill.current.Paid_2 + bill.current.Paid;
          }

          formData.append("payment", total_payment.toFixed(2));
          formData.append("Payment_method", bill.current.PaymentMethod_2);
          formData.append("Account_no", bill.current.Account_no_2);
          formData.append("Transection_no", bill.current.transection_2);

          promises.push(updateInvoice(result, formData).catch(() => {
            throw new Error("Network error: Unable to update invoice for 2nd payment.");
          }));
        }

        // Journal entries
        if (packaging_cost > 0) {
          let formData2 = new FormData();
          formData2.append("contact", bill.current.Contact);
          formData2.append("invoice", result);
          formData2.append("increase", false);
          formData2.append("location", bill.current.location);
          formData2.append("details", "Packaging items for sell invoice no.  " + bill.current.InvoiceNumber);
          formData2.append("amount", parseFloat(packaging_cost).toFixed(2));
          promises.push(
            getSpecificChartofaccountsbycode(1000100015).then((res) => {
              formData2.append("chartofaccount", res[0].id);
              promises.push(createjournals(formData2).catch(() => {
                throw new Error("Network error: Unable to create journal entry.");
              }));
            }).catch(() => {
              throw new Error("Network error: Unable to get chart of accounts.");
            })
          );
        }

        if (packaging_cost > 0) {
          let formData3 = new FormData();
          formData3.append("contact", bill.current.Contact);
          formData3.append("invoice", result);
          formData3.append("increase", true);
          formData3.append("location", bill.current.location);
          formData3.append("details", "Packaging items for sell invoice no.  " + bill.current.InvoiceNumber);
          formData3.append("amount", parseFloat(packaging_cost).toFixed(2));
          promises.push(
            getSpecificChartofaccountsbycode(400020).then((res) => {
              formData3.append("chartofaccount", res[0].id);
              promises.push(createjournals(formData3).catch(() => {
                throw new Error("Network error: Unable to create journal entry.");
              }));
            }).catch(() => {
              throw new Error("Network error: Unable to get chart of accounts.");
            })
          );
        }

        return "done";
      }

      await someProcedure();

      // Wait for all promises and catch any error
      await Promise.all(promises).catch((err) => {
        message.error(err.message || "Network error: Unable to complete order. No changes were made.");
        fullpageloading(false);
        return;
      });

      newinvoice.current = result;
      message.success("Order has been taken");
      setshowinvoice(true);
      // window.location.reload();
    } catch (err) {
      message.error(err.message || "Network error: Unable to complete order. No changes were made.");
      fullpageloading(false);
    }
  };

  return (
    <>
    {/* TOP BAR */}
      <Row  style={{ textAlign: "left", margin: "auto" }}>
        <Col span={7}>
         <b>Sales Terminal</b>
         {Auth.superuser ? (
            <Row style={{ margin: "auto" }}>
              <Col
                sm={{ span: 24 }}
                lg={{ span: 22, offset: 0 }}
                style={{ width: "100%", border:"none" }}
              >
                <Select
                  defaultValue={bill.current.location}
                  style={{ 
                    border: "none",
                    width: "100%",
                    boxShadow: 'none',
                    backgroundColor: "white"
                  }}
                  onChange={(e) => {
                    cartItems.current = [];
                    bill.current.location = e;
                    location.current = bill.current.location;
                    setCart(true);
                    setsearch(true);
                    setrealodpackage(true);
                  }}
                >
                  {WarehouseList.map((warehouse) => {
                    return (
                      <Option key={warehouse.id} value={warehouse.id}>{warehouse.name}</Option>
                    );
                  })}
                </Select>
              </Col>
            </Row>
            ) : (
              <Row style={{ margin: "auto" }}>
                <Col
                  sm={{ span: 24 }}
                  lg={{ span: 22, offset: 0 }}
                  style={{ width: "100%", border:"none" }}
                >
                  <Select
                    defaultValue={bill.current.location}
                    style={{ 
                      border: "none",
                      width: "100%",
                      boxShadow: 'none',
                      backgroundColor: "white"
                    }}
                    onChange={(e) => {
                      cartItems.current = [];
                      bill.current.location = e;
                      location.current = bill.current.location;
                      setCart(true);
                      setsearch(true);
                      setrealodpackage(true);
                    }}
                  >
                    {WarehouseList.filter(
                      (warehouse) => warehouse.id === (Auth.profile && Auth.profile.branch && Auth.profile.branch.id)
                    ).map((warehouse) => {
                      return (
                        <Option key={warehouse.id} value={warehouse.id}>{warehouse.name}</Option>
                      );
                    })}
                  </Select>
                </Col>
              </Row>
            )}
        </Col>
        <Col span={5}>
          <b>Sales Person</b>
          <Col span={24}
           offset={0}
           sm={{ span: 24 }}
           lg={{ span: 22, offset: 0 }}
            style={{ width: "100%" }}>
            <Select
              style={{ 
                border: "none",
                width: "100%",
                boxShadow: 'none', }}
              defaultValue={bill.current.Sales_person}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              onChange={(e) => {
                bill.current.Sales_person = e;
                setCart(true);
                setsearch(true);
                setrealodpackage(true);
              }}
            >
              {employeeList.map((employee) => {
                if (Auth.superuser || Auth.staff || bill.current.location == employee.Office) {
                  return (
                    <Option key={employee.id} value={employee.id}>{employee.name}</Option>
                  );
                }
                return null;
              })}
            </Select>
          </Col>
        </Col>
        <Col span={3}>
        <b>Order No.</b>
          <Col
          span={24}
            sm={{ span: 24 }}
            lg={{ span: 22, offset: 0 }}
            style={{ width: "100%" }}
          >
            <InputNumber
              value={bill.current.OrderNumber}
              disabled
              style={{ 
                border: "1px solid lightgray",
                width: "100%",
                boxShadow: 'none', }}
            />
          </Col>
        </Col>
        <Col span={4}>
        <b>Invoice Date</b>
          <Col
          span={24}
            sm={{ span: 24 }}
            lg={{ span: 22, offset: 0 }}
            style={{ width: "100%" }}
          >
            <InputNumber
              value={bill.current.TodayDate}
              disabled
              style={{ 
                border: "1px solid lightgray",
                width: "100%",
                boxShadow: 'none', }}
            />
          </Col>
        </Col>
        <Col span={5} style={{ margin: "auto" }}>
        <b>Invoice No.</b>
          <Col
          span={24}
            sm={{ span: 24 }}
            lg={{ span: 22, offset: 0 }}
            style={{ width: "100%" }}
          >
            <InputNumber
              value={bill.current.InvoiceNumber}
              disabled
              style={{ 
                border: "1px solid lightgray",
                width: "100%",
                boxShadow: 'none', }}
            />
          </Col>
        </Col>
      </Row>
      <Divider />
      <Row style={{}}>
        <Col xs={24} md={14} style={{ 
              width:"100%", 
              marginRight: "10px",
              }}>
          <Col
            style={{ 
              border: "2px solid lightgray",
               padding:"10px",
               borderRadius: "5px",
               marginBottom: "10px",
              }}
            >

        {/* PRODUCT COMPONENT */}
        <Row>
          <Col span={24}>
            <Form form={form} layout="vertical">
              <Form.Item name="remarks" label=""
              >
                <Input
                  placeholder="Enter barcode or product code"
                  onKeyUp={onKeyUp}
                  style={{ width: "100%" }}
                  onKeyDown={handleKeyDown}
                  ref={productSearchRef}
                  // tabIndex={0}
                />
              </Form.Item>
            </Form>

            {/* <Divider /> */}

            <Row>
              {data &&
                data.map((item, index) => {
                  if (
                    // item.parent_category == "CLOTHING" &&
                    
                    item.is_active 
                    // &&
                    // index < 8
                  ) {
                    return (
                      <>
                        <Col
                          span={12}
                          sm={{ span: 6 }}
                          lg={{ span: 6 }}
                          // style={{ padding: "5px" }}
                        >
                          <div
                            style={{
                              border: "1px solid lightgray",
                              padding: "5px",
                              margin:"2px",
                              textAlign: "center",
                              borderRadius: "5px",
                              // minHeight: "150px",
                              backgroundColor: "whitesmoke",
                            }}
                            onClick={(e) => {
                              if (location.current == "") {
                                alert("Please select a outlet first");
                              } else {
                                let newdiscount = 0;
                                if (item.Deatils[0].discount != null) {
                                  newdiscount = item.Deatils[0].discount;
                                  if (item.Deatils[0].discount_type == "%") {
                                    newdiscount =
                                      (item.selling_price *
                                        item.Deatils[0].discount) /
                                      100;
                                  }
                                }
                                if (cartItems.current.length > 0) {
                                  let flag = 0;
                                  cartItems.current.map((cartitem, index) => {
                                    if (cartitem.id == item.id) {
                                      cartitem.quantity = cartitem.quantity + 1;
                                      cartitem.total_price =
                                        parseFloat(cartitem.total_price) +
                                        parseFloat(item.selling_price);
                                      if (cartitem.quantity > cartitem.limit) {
                                        alert("out of stock");
                                        cartitem.quantity = cartitem.quantity - 1;
                                        cartitem.total_price =
                                          parseFloat(cartitem.total_price) -
                                          parseFloat(item.selling_price);
                                      } else {
                                        message.success(
                                          item.Deatils[0].title +
                                            " has been added"
                                        );
                                      }

                                      flag = 1;
                                    }
                                  });
                                  if (flag == 0) {
                                    const arr = {
                                      id: item.id,
                                      title: item.Deatils[0].title,
                                      product_code: item.Deatils[0].product_code,
                                      color: item.color,
                                      Color: item.Color,
                                      size: item.size,
                                      Size: item.Color,
                                      purchase_price: item.purchase_price,
                                      price: item.selling_price,
                                      total_price: item.selling_price,
                                      quantity: 1,
                                      limit: item.quantity,
                                      discount: newdiscount,
                                      product_discount: item.Deatils[0].product_discount,
                                      product_discount_reduce: ((item.selling_price * (item.Deatils[0].product_discount / 100)))
                                    };
                                    cartItems.current.push(arr);
                                    message.success(
                                      item.Deatils[0].title + " has been added"
                                    );
                                  }
                                  console.log(item.id);
                                  setCart(true);
                                } else {
                                  const arr = {
                                    id: item.id,
                                    title: item.Deatils[0].title,
                                    product_code: item.Deatils[0].product_code,
                                    color: item.color,
                                    Color: item.Color,
                                    size: item.size,
                                    Size: item.Color,
                                    purchase_price: item.purchase_price,
                                    price: item.selling_price,
                                    total_price: item.selling_price,
                                    quantity: 1,
                                    limit: item.quantity,
                                    discount: newdiscount,
                                    product_discount: item.Deatils[0].product_discount,
                                    product_discount_reduce: ((item.selling_price * (item.Deatils[0].product_discount / 100)))
                                  };
                                  message.success(
                                    item.Deatils[0].title + " has been added"
                                  );
                                  cartItems.current.push(arr);
                                }
                              }
                              // cartItems.current = arr;
                              // productSearchRef.current.focus();
                              setTimeout(() => productSearchRef.current.focus(), 0);
                              form.resetFields();
                              setdata([]);
                              setCart(true);
                            }}
                          >
                            <p style={{marginBottom:"-2px", fontSize:"14px"}}>{item.Deatils[0].title}</p>
                            {console.log(item)}
                            {/* {renderImage(item.image)} */}
                            <p style={{marginBottom:"-2px", fontSize:"12px"}}>Quantity: {item.quantity}</p>
                            <p style={{marginBottom:"-2px", fontSize:"12px"}}>Attributes: {item.color} / {item.size}</p>
                          </div>
                        </Col>
                      </>
                    );
                  }
                })}
            </Row>
          </Col>
        </Row>
          </Col>
          <Row style={{backgroundColor: "",borderRadius: "5px",border:"1px solid lightgray" }}>
            <Row style={{width:"100%", textAlign:"center"}}>
              <Col span={8}></Col>
              <Col span={8}><h4 style={{textAlign:"center", color:"green"}}><b>Order Details</b></h4></Col>
              <Col span={8}></Col>
            </Row>
            <Row style={{width:"100%"}}>
              <Col span={1}>
              </Col>
              <Col span={3}>
                <h4><b>SKU</b></h4>
              </Col>
              <Col span={4}>
                <h4><b>Style</b></h4>
              </Col>
              {/* <Col span={3}>
                <h4><b>Color</b></h4>
              </Col>
              <Col span={2}>
                <h4><b>Size</b></h4>
              </Col> */}
              <Col span={4}>
                <h4><b>Variation</b></h4>
              </Col>
              
              <Col span={2} style={{ textAlign: "center" }}>
                <h4><b>Qty</b></h4>
              </Col>
              <Col span={4} style={{ textAlign: "center" }}>
                <h4><b>Discount</b> </h4>
              </Col>
              <Col span={5} style={{ textAlign: "center" }}>
                <h4><b>Price</b> </h4>
              </Col>
              {/* <Col span={3} style={{ textAlign: "center" }}>
                <h4><b>Dis. Price</b> </h4>
              </Col> */}
              <Col span={1} style={{ textAlign: "center" }}>
              </Col>
            </Row>        
       
          </Row>
            {cartItems.current.map((item) => {
              console.log(cartItems)
              const index = cartItems.current.indexOf(item);
              return (
                <>
                  <Row
                    style={{
                      padding: "4px",
                      background: "#ededed",
                      marginBottom: "0px",
                    }}
                  >
                    <Col span={1}>
                    </Col>
                    <Col span={3}>
                      <p>
                        {item.title}
                      </p>
                    </Col>
                    <Col span={4}>
                      <p>
                        {item.product_code}
                      </p>
                    </Col>
                    {/* <Col span={3}>
                      <p>
                        {item.color}
                      </p>
                    </Col>
                    <Col span={2}>
                      <p>
                      {item.size}
                      </p>
                    </Col> */}
                    <Col span={4}>
                      <p>
                      {item.size} {item.color}
                      </p>
                    </Col>
                    <Col span={2} style={{ textAlign: "center",
                    marginLeft: "auto",
                    marginBottom: "auto",
                    marginRight: "auto",
                    }}>
                      <InputNumber
                        min={1}
                        max={cartItems.current[index].limit}
                        value={cartItems.current[index].quantity}
                        onChange={(value) => {
                          const quantity = Number(value) || 0;
                          const price = Number(cartItems.current[index].price) || 0;
                          const discount = Number(cartItems.current[index].spec_discount) || 0;

                          cartItems.current[index].quantity = quantity;
                          cartItems.current[index].total_price = quantity * price - discount;

                          setCart(true);
                        }}
                        defaultValue={1}
                      />
                    </Col>
                    <Col span={4}>
                    {/* <InputNumber 
                      style={{ textAlign: "center", marginLeft: "0px", margin: "auto" }}
                      value={cartItems.current[index].spec_discount || 0}  // Ensure a valid default value
                      onChange={(e) => {
                        const discount = e !== null && e !== undefined ? e : 0;  // Avoid `??` for compatibility
                        cartItems.current[index].spec_discount = discount;
                        cartItems.current[index].total_price =
                          cartItems.current[index].quantity * cartItems.current[index].price - discount;
                        setCart(true);
                      }}
                      defaultValue={0}
                    /> */}
                      <InputNumber 
                        disabled
                        style={{ textAlign: "center", marginLeft: "0px", margin:"auto" }}
                        value={cartItems.current[index].spec_discount}
                        // onChange={(e) => {
                        //   cartItems.current[index].spec_discount  = e;
                        //   cartItems.current[index].total_price = cartItems.current[index].price - e ;

                        //   setCart(true);
                        // }}
                        onChange={(e) => {
                          cartItems.current[index].spec_discount = e;
                          // Recalculate total_price with discount
                          cartItems.current[index].total_price =
                          cartItems.current[index].quantity * cartItems.current[index].price - e;
                            // cartItems.current[index].quantity * cartItems.current[index].price * (1 - e / 100);  // percentage discount                       
                          setCart(true);
                        }}
            
                        defaultValue={0}
                      />

                    </Col>
                    <Col span={4}  style={{ textAlign: "center" }}>
                    {item.total_price}
                    {/* </Col>
                    <Col span={3} style={{ textAlign: "center",
                                        marginRight: "auto",
                                        marginLeft: "auto",
                                        marginBottom: "auto",
                    }}>
                      {item.total_price - (item.total_price * (item.product_discount / 100))} */}
                      <DeleteOutlined
                        style={{ color: "Red", float: "right",
                        marginRight: "auto",
                        marginLeft: "auto",
                        marginBottom: "auto",
                        marginTop: "4px",
                        }}
                        onClick={(e) => {
                          for (let i = 0; i < measurements.current.length; i++) {
                            if (measurements.current[i].product == item.id) {
                              measurements.current.splice(i, 1);
                            }
                          }
                          cartItems.current.splice(index, 1);
                          setCart(true);
                        }}
                      />
                    </Col>
                    <Col span={1}></Col>
                  </Row>
                  <Divider style={{
                    marginTop:"1px",
                    marginBottom:"1px",
                    }}>

                  </Divider>
                </>
              );
            })}

          {/* Payment Information */}
          <Row style={{
            backgroundColor: "",borderRadius: "5px",border:"1px solid lightgray", marginTop:"10px"  }}>
              <Row style={{width:"100%", textAlign:"center"}}>
                  <Col span={8}></Col>
                  <Col span={8}><h4 style={{textAlign:"center", color:"green"}}><b>Payment Information</b></h4></Col>
                  
                  {bill.current.Paid > 0 ? (
                  <>
                    <Col span={8}>
                      <Row>
                        {/* ### PAYMENT ON/OFF ### */}
                        <Col span={12}>
                        </Col>
                        <Col span={12}></Col>
                      </Row>
                      
                    </Col>
                  </>
                    ) : (
                    ""
                  )}
              </Row>

              <Row style={{ borderRadius: "5px",border:"1px solid lightgray", margin:"10px",
                width:"100%", textAlign:"center", backgroundColor:"", padding:"5px"}}>
                <Col span={6} style={{
                  marginRight:"0px", textAlign:"center",  padding:"5px",backgroundColor:""
                  }}>
                  <Row style={{width:"100%", textAlign:"center",}}>
                    Payment Method
                  </Row>
                  <Row style={{width:"100%", textAlign:"center",}}>
                      <Select
                        defaultValue="Cash"
                        style={{ width: "100%" }}
                        onChange={(e) => {
                          bill.current.PaymentMethod = e;
                          if (e !== "Cash") {
                            const defaultAccount = accounts.find(
                              (account) => account.type === e
                            );
                            bill.current.AccountNumber = defaultAccount
                              ? defaultAccount.id
                              : "";
                          } else {
                            bill.current.AccountNumber = "";
                          }
                          setCart(true);
                        }}
                      >
                      <Option value="Cash">Cash</Option>
                      <Option value="Bank">Bank</Option>
                      <Option value="Mobile banking">Mobile banking</Option>
                    </Select>
                  </Row>
                </Col>

                <Col span={6} style={{
                  marginRight:"0px", textAlign:"center", padding:"5px", backgroundColor:""}}>
                  {bill.current.PaymentMethod != "Cash" ? (
                    <>
                      <Row style={{width:"100%", textAlign:"center",}}>
                          <span style={{ color: "red" }}>*</span>Account
                      </Row>
                      <Row style={{width:"100%", textAlign:"center",}}>
                          <Select
                            value={bill.current.AccountNumber}
                            style={{ width: "100%" }}
                            onChange={(e) => {
                              bill.current.AccountNumber = e;
                              setCart(true);
                            }}
                          >
                            {accounts.map((account) => {
                              if (account.type == bill.current.PaymentMethod) {
                                return (
                                  <Option value={account.id}>
                                    {account.name}
                                  </Option>
                                );
                              }
                            })}
                          </Select>
                      </Row>
                    </>
                    ) : (
                      ""
                  )}
                </Col>

                {bill.current.PaymentMethod == "Cash" ? (
                ""
                ) : (
                <Col span={6} style={{
                  marginRight:"0px", textAlign:"center", padding:"5px",backgroundColor:""}}>
                  <Row style={{width:"100%", textAlign:"center",}}>
                    Account No
                  </Row>
                  <Row style={{width:"100%", textAlign:"center",}}>
                    <InputNumber
                    onChange={(e) => {
                      bill.current.Account_no = e;
                      }}
                    />
                  </Row>
                </Col>
                )}

                {bill.current.PaymentMethod == "Cash" ? (
                  ""
                ) : (
                <Col span={6} style={{
                  marginRight:"0px", textAlign:"center", padding:"5px",backgroundColor:""}}>
                  <Row style={{width:"100%", textAlign:"center",}}>
                    Transaction No
                  </Row>
                  <Row style={{width:"100%", textAlign:"center",}}>
                    <Row span={12} offset={1} style={{ textAlign: "center" }}>
                      <InputNumber
                        onChange={(e) => {
                          bill.current.transection = e;
                        }}
                      />
                    </Row>
                  </Row>
                </Col>
                )}
              </Row>

                {/* ############### FIRST PAYMENT ############### */}
              <Row style={{ borderRadius: "5px",border:"1px solid lightgray", margin:"10px",
                width:"100%", textAlign:"center", backgroundColor:"", padding:"5px"}}>
                  <Col span={11} style={{ textAlign: "right" }}>
                    <h3 style={{ color: "green" }}><span style={{ color: "red" }}>*</span><b>First Payment</b></h3>
                  </Col>
                  <Col span={12} offset={1} style={{ textAlign: "center" }}>
                    <InputNumber
                      min={0}
                      value={receive}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          submitOrder();
                        }
                      }}
                      onChange={(e) => {
                        if (bill.current.Contact == null) {
                          alert("Please select a customer first");
                        } else if (e != "" && e != null) {
                          bill.current.Paid = e;
                          setReceive(e);
                          setPaidError(null);
                          setservicetrigger(true);
                          setCart(true);
                        } else {
                          bill.current.Paid = 0;
                          setPaidError("Please enter a Receive amount");
                          setReceive(0);
                          setservicetrigger(true);
                          setCart(true);
                        }
                      }}
                    />
                    {paidError && <div style={{ color: "red" }}>{paidError}</div>}
                  </Col>
                </Row>
          </Row>

          {/* Submit Order */}
          <Row 
            style={{
            backgroundColor: "",borderRadius: "5px",border:"0px solid lightgray", marginTop:"10px", width:"100%", padding:"5px", }}
            >
            <Col Span={8} style={{ 
              textAlign: "left",  fontSize:"20px" }}>
                <p><b>Total Qty:</b> <b style={{color:"red"}}>{bill.current.totalQty}</b></p>
                
            </Col>
            <Col Span={8} style={{ 
              textAlign: "right", marginLeft:"auto", marginRight:"auto", }}>
              <Row><AddShipping bill={bill} /></Row>
              {/* <Row><AddService service={services} setservicetrigger={setservicetrigger} product={0}/></Row> */}
            </Col>
            <Col Span={8} style={{ 
              textAlign: "right", marginLeft:"", marginRight:"", }}>
              <Button type="primary" 
                icon={<DownloadOutlined />} 
                size="large" 
                onClick={submitOrder}
                ref={confirmOrderRef}
                onKeyDown={handleKeyDown}
                >
                Confirm Order
              </Button>
            </Col>
          </Row>  
        </Col>

        {/* ############# CUSTOMER DETAILS ############### */}
        <Col span={9} style={{
          width:"100%",
          marginLeft:"10px"
          }}>
          <Row 
            style={{
            width:"100%",
            border: "1px solid lightgray",
            borderRadius: "5px",
            }}
            >
            <Col span={24} style={{
                textAlign: "center",
              }}>
              <h4 style={{textAlign:"center", color:"green"}}>
                <b>Customer Details</b>
              </h4>
            </Col>
 
            <Col span={23}
              style={{
                width:"80%",
                padding: "10px",
                border: "1px solid lightgray",
                borderRadius: "5px",
                margin:"10px",
                }}
            >
              {remove ? (
                <Row vertical>
                  <Button Danger
                    onClick={() => {
                    setremove(false);
                    setcontact(null);
                    bill.current.Payable = 0;
                    bill.current.Contact = null;
                    setCart(true);
                  }}
                  // type="link"
                  style={{color: "red", border: "1px solid red"}}
                >
                  Remove Contact
                </Button>
                </Row>

          
              ) : (
                <Space direction="Horizontal" style={{ width: "100%" }}>
                  <Input
                    placeholder="Customer Phone Number"
                    prefix={<UserOutlined />}
                    // onKeyUp={onChange}
                    onChange={onChangeContact}
                    // ref={contactSearchRef}
                    // onKeyDown={handleKeyDown}

                    style={{
                      width: '100%',
                    }}
                  />
                  <CreateNewContct 
                  bill={bill} 
                  setcontact={setcontact} 
                  // triggerOpen={triggerOpen} 
                  triggerOpen={triggerDrawer}
                  phone={searchPhone}
                  onClose={handleDrawerClose}
                  />
                </Space>
                
              )}
              <div
                style={{
                  position: "absolute",
                  zIndex: "5",
                  backgroundColor: "#F5F5F5",
                  width: "100%",
                }}
              >
                {renderContact()}
              </div>
              <br></br>
              {contact ? (
                <>
                  {contact.name ? (
                      <>
                        <Row>
                          <Col span={6}>
                            <b>Name</b>
                          </Col>
                          <Col span={18}>
                            <Input value={contact.name} disabled style={{color:"#545252"}} />
                          </Col>
                        </Row> 
                      </> 
                      ) : (
                        ""
                        )}

                        {contact.role ? (
                          <>
                            <Row>
                              <Col span={6}>
                                <b>Type</b>
                              </Col>
                              <Col span={18}>
                                <Input value={contact.Role} disabled style={{color:"#545252"}} />
                              </Col>
                            </Row> 
                          </>
                        ) : (
                          ""
                        )}
                        {contact.address ? (
                          <>
                            <Row>
                              <Col span={6}>
                                <b>Address</b>
                              </Col>
                              <Col span={18}>
                                <Input.TextArea value={contact.address} disabled style={{color:"#545252"}} />
                              </Col>
                            </Row> 
                          </>
                        ) : (
                          ""
                        )}
                  
                        {contact.phone ? (
                          <>
                          <Row>
                              <Col span={6}>
                                <b>Phone</b>
                              </Col>
                              <Col span={18}>
                                <Input value={contact.phone} disabled style={{color:"#545252"}} />
                              </Col>
                            </Row> 
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    
                  ) : (
                    ""
                  )}

              {/* {typeof id == "undefined" ? (
                <ContactSearchFromInvoice
                  bill={bill}
                  setCart={setCart}
                  id={0}
                  triggerOpen={triggerDrawer}
                />
                ) : (
                <ContactSearchFromInvoice
                  bill={bill}
                  setCart={setCart}
                  id={id}
                  triggerOpen={triggerDrawer}
                />
                )} */}
            </Col>
          </Row>
          <Row
            style={{ 
            backgroundColor: "#FFFEF9", 
            marginTop: "10px",
            border: "2px solid lightgray",
            borderRadius: "5px",
            }}
            >
            <Col span={24} style={{
                textAlign: "center",
              }}>
              <h4 style={{textAlign:"center", color:"green"}}>
                <b>Billing Details</b>
              </h4>
            </Col>
 
            <Col span={23}            
              style={{
                width:"80%",
                padding: "10px",
                border: "1px solid lightgray",
                borderRadius: "5px",
                margin:"10px",
                }}
              >
                <Row>
                  <Col span={8} style={{ textAlign: "left" }}>
                    <h3>VAT</h3>
                  </Col>
                  <Col span={14} offset={1} style={{ textAlign: "center" }}>
                    <InputNumber
                      value={Math.abs(bill.current.Tax.toFixed(2))}
                      disabled
                      style={{ color: "black", borderRadius: "5px" }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8} style={{ textAlign: "left" }}>
                    <h3> Sub Total</h3>
                  </Col>
                  <Col span={14} offset={1} style={{ textAlign: "center" }}>
                    <InputNumber
                      value={bill.current.subTotal}
                      disabled
                      style={{ color: "black", borderRadius: "5px" }}
                    />
                  </Col>
                </Row>

                {/* Coupon Discount */}
                <Row>
                  {bill.current.Cupon == null ? (
                    <>
                      <Col span={8} style={{ textAlign: "left" }}>
                        <h3> Coupon</h3>
                      </Col>
                      <Col span={10} offset={1} style={{ textAlign: "center" }}>
                        <Input
                        style={{ color: "black", borderRadius: "5px" }}
                          onChange={(e) => {
                            bill.current.Cupon_name = e.target.value;
                          }}
                        />
                      </Col>
                      <Col span={2} style={{ textAlign: "center" }}>
                        <Button
                          type="primary"
                          onClick={() => {
                            getCuponSearchResult(bill.current.Cupon_name).then(
                              (result) => {
                                if (result.length == 1) {
                                  if (result[0].status == "Active") {
                                    if (
                                      (result[0].limit_type == "limited" &&
                                        result[0].limit > 0) ||
                                      result[0].limit_type == "Unlimited"
                                    ) {
                                      var currentdate = new Date();

                                      var d1 = dateFormat(
                                        result[0].start,
                                        "yyyy-mm-dd HH:MM:ss"
                                      );
                                      var d2 = dateFormat(
                                        result[0].end,
                                        "yyyy-mm-dd HH:MM:ss"
                                      );
                                      var current = dateFormat(
                                        currentdate,
                                        "yyyy-mm-dd HH:MM:ss"
                                      );
                                      var date1 = new Date(d1);
                                      var date2 = new Date(d2);
                                      var currenttime = new Date(current);

                                      var diff1 =
                                        currenttime.getTime() - date1.getTime();
                                      var diff2 =
                                        date2.getTime() - currenttime.getTime();
                                      var lte = diff1 / (1000 * 3600 * 24);
                                      var gte = diff2 / (1000 * 3600 * 24);

                                      if (lte >= 0 && gte >= 0) {
                                        message.success(
                                          "Coupon has been applied"
                                        );
                                        bill.current.Cupon = result[0];
                                        setCart(true);
                                      }
                                    }
                                  }
                                }
                              }
                            );
                          }}
                        >
                          Apply
                        </Button>
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                  <Col span={8} style={{ textAlign: "left" }}></Col>
                  <Col span={12} style={{ textAlign: "center" }}>
                    {bill.current.Cupon != null ? (
                      <small>
                        Coupon discount: {parseInt(bill.current.Cupon.amount)}
                        {bill.current.Cupon.ref_type == "A" ? " BDT" : "%"}
                        <Button
                          type="link"
                          style={{ color: "red" }}
                          onClick={() => {
                            bill.current.Cupon = null;
                            bill.current.Discount = 0;
                            setCart(true);
                            setservicetrigger(true);
                          }}
                        >
                          x
                        </Button>
                      </small>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>

                  {bill.current.Cupon != null ? (
                  <Row>
                    <Col span={8} style={{ textAlign: "left" }}>
                      <h3>Coupon Disc</h3>
                    </Col>
                    <Col span={12} offset={1} style={{ textAlign: "center" }}>
                      <InputNumber
                        disabled
                        // max={bill.current.MaxDiscount}
                        value={bill.current.Discount}
                        onChange={(e) => {
                          if (e > 0) {
                            bill.current.Discount = e;
                            setCart(true);
                          } else {
                            bill.current.Discount = 0;
                            setCart(true);
                          }
                        }}
                      />
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                {/* Coupon Discount End */}


                <Row>
                  <Col span={8} style={{ textAlign: "left" }}>
                        <h3>Sales Disc. <small style={{ color: "red" }}>(-)</small></h3>
                  </Col>
                  <Col span={14} offset={1} style={{ textAlign: "center" }}>
                    <InputNumber
                    style={{ color: "black", borderRadius: "5px" }}
                      value={bill.current.Discount}
                      onChange={(e) => {
                        if (e > 0) {
                          bill.current.Discount = e;
                          setCart(true);
                        } else {
                          bill.current.Discount = 0;
                          setCart(true);
                        }
                      }}
                      ref={salesDiscountRef}
                      onKeyDown={handleKeyDown}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8} style={{ textAlign: "left" }}>
                        <h3>Add Disc.{"  "}<small style={{ color: "red" }}>(-)</small></h3>
                  </Col>
                  <Col span={14} offset={1} style={{ textAlign: "center" }}>
                    <InputNumber
                    style={{ color: "black", borderRadius: "5px" }}
                    // ref={productDiscountRef}
                    // onKeyDown={handleKeyDown}
                    // value={bill.current.ProductDiscountTotal}
                    value={cartItems.current.reduce((total, item) => total + item.spec_discount, 0)}
                    defaultValue={0}
                    disabled
                    />
                  </Col>
                </Row>
                
              <Row>
                <Col span={8} style={{ textAlign: "left" }}>
                  <h3>Grand Total</h3>
                </Col>
                <Col span={14} offset={1} style={{ textAlign: "center" }}>
                  <InputNumber
                    value={bill.current.Total}
                    disabled
                    style={{ color: "black" }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col span={14}>
          <Divider style={{ marginTop: "20px" }} />
          <Row>
            <Col sm={{ span: 24 }} lg={{ span: 10 }}>
              <Space direction="vertical" style={{ width: "100%" }}>


              </Space>
            </Col>
            <Col
            >
              
            </Col>
          </Row>
        </Col>
      </Row>

      <Divider />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    Auth: state.auth,
    List: state.ProductDetails.productdetails,
    Contacts: state.contacts.contactlistsearchresult,
    WarehouseList: state.warehouse.outletlist,
    employeeList: state.employee.employeelist,
  };
};

export default connect(mapStateToProps, {
  getProductSearchResult,
  createInvoiceItem,
  createInvoice,
  updateVariationfromSrock,
  createService,
  getAllOutlet,
  createMeasurement,
  createjournals,
  getAllAccount,
  getSpecificChartofaccountsbycode,
  getCuponSearchResult,
  updateCupon,
  updateInvoice,
  getAllEmployee,
  getProductSearchResultforsales,
  getContactSearchResultbyPhone,
  getSpecificContact,
  getSpecificMeasurementbycontact,
  getCuponSearchResult,
})(SearchStock);
